import { useEffect } from "react";
import app from "nystem";

const RouterSwipe = ({ model }) => {
  useEffect(() => {
    const handleChange = (event) => {
      if (model.count && parseInt(model.count, 10) !== event.count) return;

      const delta = model.vertical ? event.dy : event.dx;

      if (model.limit > 0 ? delta - model.limit > 0 : delta - model.limit < 0)
        window.history.pushState({}, "", model.path);
    };

    app.on("pointer", handleChange);
    return () => {
      app.off("pointer", handleChange);
    };
  }, [model]);

  return null;
};
export default RouterSwipe;
